import { App } from "@app/interfaces"
import { useAuth } from "@app/hooks"
import { hasModuleWriteAccess } from "@app/utils"

/**
 * Есть ли у текущего пользователя доступ на запись к модулю гостевых ботов.
 * Гостевые боты относятся к модулю `tg_mailing` (отдельной роли нет).
 * Для OIDC — проверяем модульную роль `tg_mailing:w`.
 * Для STANDARD-авторизации — считаем, что запись доступна менеджеру/админу.
 */
export const useGuestBotWriteAccess = (): boolean => {
  const auth = useAuth()

  if (!auth) {
    return false
  }

  if (auth.type === App.AuthType.OIDC) {
    const userInfo = auth.userInfo as App.OIDCUserInfo | undefined
    const roles = userInfo?.roles ?? []
    return hasModuleWriteAccess(roles, App.ModuleName.TG_MAILING)
  }

  return (auth.role ?? App.UserRole.ANON) >= App.UserRole.MANAGER
}
